import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Typography, Button, Paper } from '@mui/material';
import { PendingActions } from '@mui/icons-material';

export default function PendingScreen() {
  return (
    <Box sx={{ maxWidth: 500, mx: 'auto', mt: 4 }}>
      <Paper sx={{ p: 4, textAlign: 'center' }}>
        <PendingActions sx={{ fontSize: 64, color: 'warning.main', mb: 2 }} />
        <Typography variant="h5" gutterBottom>Account pending approval</Typography>
        <Typography color="text.secondary" paragraph>
          Your registration has been submitted. An administrator will approve your account. You can check back later or contact support.
        </Typography>
        <Button component={Link} to="/prototype/login" variant="contained">Back to Login</Button>
      </Paper>
    </Box>
  );
}
